import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './title_secondary.scss'
import themeTypes from 'helpers/enums/themes/themeTypes'
import getThemeClassResolver from 'helpers/themes/themeClassResolver'

const SecondaryTitle = props => (
	<h2 styleName={
		classNames({
			'title--centered': props.isCentered ? true : false,
			'title--has-icon': props.icon ? true : false,
			title: true,
			...getThemeClassResolver([themeTypes.DARK, themeTypes.LIGHT], 'title--', props.theme),
		})
	}>
		{ props.icon &&
				<div styleName='title_icon'>
					{props.icon}
				</div>
		}
		<span styleName='title_text'>{props.children}</span>
	</h2>
)

SecondaryTitle.propTypes = {
	children: PropTypes.node,
	isCentered: PropTypes.bool,
	icon: PropTypes.node,
	theme: PropTypes.oneOf([themeTypes.LIGHT, themeTypes.DARK]),
}

SecondaryTitle.defaultProps = {
	isCentered: false,
	icon: null,
	text: '',
	theme: themeTypes.LIGHT,

}

export default CSSModules(SecondaryTitle, styles, {allowMultiple: true})
